import { render, staticRenderFns } from "./Newsletter1.vue?vue&type=template&id=4e1918e0&scoped=true"
import script from "./Newsletter1.vue?vue&type=script&lang=ts"
export * from "./Newsletter1.vue?vue&type=script&lang=ts"
import style0 from "./Newsletter1.vue?vue&type=style&index=0&id=4e1918e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1918e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
